import { Badge } from '@/components/ui/badge'
import { CheckCircle2, AlertCircle, CircleDashed } from 'lucide-react'

interface EstadoConexionBadgeProps {
  ultimoUso: string | null
  ultimoError: string
  activo: boolean
}

export function EstadoConexionBadge({ ultimoUso, ultimoError, activo }: EstadoConexionBadgeProps) {
  if (!activo) {
    return (
      <Badge variant="outline" className="inline-flex items-center gap-1.5 h-8 px-3 border-gray-300 text-gray-600 dark:border-gray-600 dark:text-gray-300">
        <CircleDashed className="h-3 w-3" />
        Inactivo
      </Badge>
    )
  }
  if (ultimoError) {
    return (
      <Badge variant="outline" className="inline-flex items-center gap-1.5 h-8 px-3 border-pink-400 text-pink-600 dark:border-pink-700 dark:text-pink-400">
        <AlertCircle className="h-3 w-3" />
        Error en última llamada
      </Badge>
    )
  }
  if (!ultimoUso) {
    return (
      <Badge variant="outline" className="inline-flex items-center gap-1.5 h-8 px-3 border-yellow-400 text-yellow-700 dark:border-yellow-700 dark:text-yellow-500">
        <CircleDashed className="h-3 w-3" />
        Sin conexión previa
      </Badge>
    )
  }
  return (
    <Badge variant="outline" className="inline-flex items-center gap-1.5 h-8 px-3 border-green-500 text-green-600 dark:border-green-700 dark:text-green-400">
      <CheckCircle2 className="h-3 w-3" />
      Conexión activa
    </Badge>
  )
}
